import { AllowanceFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

const getNaturalHours = (count: number) => {
  return i18n.tp('settings.timeoff_allowances.count_natural_hours', { count })
}

const getNaturalDays = (count: number) => {
  return i18n.tp('settings.timeoff_allowances.count_natural_days', { count })
}

const getWorkingHours = (count: number) => {
  return i18n.tp('settings.timeoff_allowances.count_working_hours', { count })
}

const getWorkingDays = (count: number) => {
  return i18n.tp('settings.timeoff_allowances.count_working_days', { count })
}

export const getAllowanceSubtitle = (allowance: AllowanceFragment) => {
  const holidayAllowance = (allowance.holidayAllowanceInCents || 0) / 100

  if (allowance.unlimitedHolidays) {
    return allowance.allowanceType === 'hours'
      ? i18n.t('settings.timeoff_allowances.unlimited_holidays_hours')
      : i18n.t('settings.timeoff_allowances.unlimited_holidays_days')
  }

  switch (allowance.daysType) {
    case 'natural_days':
    case 'natural_days_only_range':
      return allowance.allowanceType === 'hours'
        ? getNaturalHours(holidayAllowance)
        : getNaturalDays(holidayAllowance)

    case 'french_calendar_days':
      return i18n.tp('settings.timeoff_allowances.count_ouvrables_days', {
        count: holidayAllowance,
      })
  }

  switch (allowance.sourceUnits) {
    case 'by_worked_time':
      return i18n.t('settings.timeoff_allowances.by_worked_hours')
    case 'overtime_units':
      return i18n.t('settings.timeoff_allowances.overtime_compensation')
  }

  return allowance.allowanceType === 'hours'
    ? getWorkingHours(holidayAllowance)
    : getWorkingDays(holidayAllowance)
}
